import React, { useState, useEffect } from 'react';
import { ExamService } from '@services';
import SpinnerLoader from '@components/shared/loaders/spinner/SpinnerLoader';
import { useSnackbar } from '@components/utilities/SnackbarProvider';

async function getEntity(payload, entities) {
  const entityService = new entities();
  const entityResponse = await entityService.get(payload);

  if (!entityResponse || !entityResponse.result || !entityResponse.success) {
    return null;
  }

  return entityResponse;
}

async function updateEntity(payload, entity) {
  const entityService = new entity();
  const entityResponse = await entityService.update(payload);

  if (!entityResponse || !entityResponse.result || !entityResponse.success) {
    return null;
  }
  return entityResponse.result;
}

function ExamDelete({ id, onUpdatedEntity, setIsOpen }) {
  const { openSnackbar } = useSnackbar();

  const [model, setModel] = useState({
    user: { role: { name: 'regular' } },
    entity: {},
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const entityResponse = await getEntity(
          {
            id: id,
          },
          ExamService,
        );

        if (!entityResponse) {
          openSnackbar('Examen no encontrado.', 'error');
          return;
        }

        const examData = entityResponse.result;
        setModel((prevData) => ({
          ...prevData,
          entity: {
            name: examData.name,
            courseId: examData.course_id,
            course: examData.course,
            module: examData.module_id,
            is_active: examData.is_active,
            min_score: examData.min_score,
            time_limit: examData.time_limit,
            max_attempts: examData.max_attempts,
            questionsTemp: JSON.parse(examData.questions),
          },
        }));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [id]);

  const confirmOnClick = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    setIsLoading(true);
    try {
      const updateStatusDelete = {
        id: id,
        status: {
          id: 3,
          name: 'deleted',
          title: 'Eliminado',
        },
      };

      const entityResult = await updateEntity(updateStatusDelete, ExamService);

      if (!entityResult) {
        openSnackbar('Ocurrio un error al eliminar el examen', 'error');
        setIsLoading(false);
        return;
      }

      openSnackbar('Examen eliminado con exito!', 'success');

      onUpdatedEntity('delete', entityResult);
      setIsOpen(false);
    } catch (error) {
      openSnackbar('Ocurrió un error inesperado!', false);
    } finally {
      setIsLoading(false);
    }
  };

  const returnOnClick = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    setIsOpen(false);
  };

  return (
    <>
      <div className="col-12 mx-auto d-block">
        <div className="pt-2 text-center">
          <h2 className="mb-3">
            Eliminar
            <span className="ms-3">"{model.entity.name}"</span>
          </h2>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <div>
              <p className="card-description fs-4">
                ¿Estás seguro de que quieres eliminar?
              </p>
              <section className="mt-4">
                <button
                  className="btn btn-danger mr-2"
                  onClick={confirmOnClick}
                >
                  <i className="fe-trash"></i> Eliminar
                </button>

                <button
                  className="btn btn-light btn-action ms-2"
                  onClick={returnOnClick}
                >
                  <i className="fe-x"></i> Cancelar
                </button>
              </section>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ExamDelete;
